import { User } from 'packages/lib/api/annotations-app-api/contract';

export const MOTIONAL_ORGANIZATION = 'Motional AD Inc.';
export const IMERIT_ORGANIZATION = 'iMerit';

const ACTIVE_STATUS = 'ACTIVE';

export function isMotionalUser(
  user: User | Pick<User, 'organization'> | null | undefined
): boolean {
  return user?.organization === MOTIONAL_ORGANIZATION;
}

export function isActiveUser(
  user: User | Pick<User, 'status'> | null | undefined
): boolean {
  return user?.status === ACTIVE_STATUS;
}
